<script setup lang="ts">
  import ManagerIcon from '@/components/Global/Manager/ManagerIcon.vue'
  import ManagerTextButton from '@/components/Global/Manager/Forms/ManagerTextButton.vue'

  const props = withDefaults(
    defineProps<{
      removable?: boolean
    }>(),
    {
      removable: false,
    }
  )
  const emit = defineEmits<{ (e: 'remove'): void }>()
</script>

<template>
  <div
    class="bg-mbg2 rounded-[60px] text-sm flex items-center px-4 py-2 mr-2 mb-2"
  >
    <div class="whitespace-nowrap">
      <slot />
    </div>

    <ManagerTextButton
      v-if="props.removable"
      class="ml-6"
      @click="emit('remove')"
    >
      <ManagerIcon icon="close" color="mgray2" />
    </ManagerTextButton>
  </div>
</template>
